import { hashObject } from "../helpers/object-util.js";

/**
 * List of information to be shown in the Release Notes documents.
 */

export const newFeatures = [
	"Notifications from Period report drafts",
	'Add the button "New custom KPI" to the KPI page',
];

export const improvements = [
	"Downloading the client user and consultants to CSV-file",
	"Need visibility to see which agencies that are linked to each package",
	"Merge Forecasting trend to the Forecasting feature",
];

export const bugfixes = [
	"IT Revisor - API error",
	"Black cells in export to Excel",
	"Change to interval editor in step 6 in the forecast onboarding",
	"Missing translation in Crowdin",
];

export const releaseNotesVersion = hashObject({
	newFeatures,
	improvements,
	bugfixes,
});
